import HandsonTable from "../../../../../components/handsonTable/handsonTable";
import { connect } from "react-redux";

export default connect((state) => ({
  data: state.conversionInfo.data,
  colHeaders: state.conversionInfo.colHeaders,
  columns: state.conversionInfo.columns,
  // stretchH: 'all',
  width: 808,
  height: 500,
  colWidths: [325, 100, 125, 125, 125],
  columnSorting: true
}))(HandsonTable);
